//////////////////////////////////////////////////////////////////////////////////////////   IMPORT
///////////////////////////////////////////////////////////   REACT
import React from 'react';
///////////////////////////////////////////////////////////   LIBS
import Accordion from 'react-bootstrap/Accordion';
import Table from 'react-bootstrap/Table';
///////////////////////////////////////////////////////////   SCSS
import './help-panel.styles.scss';

//////////////////////////////////////////////////////////////////////////////////////   CLASS SETUPD
class HelpPanel extends React.Component {
  render() {
    return (
      <Accordion defaultActiveKey='0'>
        <Accordion.Item eventKey='0'>
          <Accordion.Header>Gyorsbillentyűk</Accordion.Header>
          <Accordion.Body>
            <Table className='table-styled'>
              {/*TODO:: remove
              Help update needed
              */}
              <tbody>
                <tr>
                  <td>Space</td>
                  <td>Elindítás, megállítás</td>
                </tr>
                <tr>
                  <td>Jobbra - Balra gomb</td>
                  <td>1 frame léptetés</td>
                </tr>
                <tr>
                  <td>Fel-le gomb</td>
                  <td>1 másodperces léptetés</td>
                </tr>
                <tr>
                  <td>F</td>
                  <td>Teljesképernyős mód váltása</td>
                </tr>
                <tr>
                  <td>M</td>
                  <td>Némítás váltása</td>
                </tr>
                <tr>
                  <td>Numerikus billentyűzet</td>
                  <td>1-9-ig százalékos léptetés a videón. Pl. az 5-ös gomb videó közepére ugrik.</td>
                </tr>
              </tbody>
            </Table>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  }
}

export default HelpPanel;
